"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

var cloud = function cloud() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 14 10"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6E6D71",
    d: "M3.333 10Q1.941 10 .97 9.03 0 8.057 0 6.666q0-1.205.786-2.148a3.12 3.12 0 0 1 1.996-1.124A4.18 4.18 0 0 1 4.291.945 4.22 4.22 0 0 1 7 0q1.83 0 3.081 1.27 1.252 1.268 1.252 3.063v.334h.205q1.11.081 1.786.873.675.791.676 1.777a2.6 2.6 0 0 1-.776 1.899 2.56 2.56 0 0 1-1.89.784zm0-1h8a1.6 1.6 0 0 0 1.184-.483A1.6 1.6 0 0 0 13 7.333a1.6 1.6 0 0 0-.483-1.183 1.6 1.6 0 0 0-1.184-.483h-1V4.333q0-1.383-.975-2.358A3.21 3.21 0 0 0 7 1q-1.108 0-1.979.662A3.23 3.23 0 0 0 3.844 3.37 3.37 3.37 0 0 1 5.84 4.467q.825.906.826 2.2h-1q0-.968-.684-1.65a2.25 2.25 0 0 0-1.65-.684q-.966 0-1.65.684A2.25 2.25 0 0 0 1 6.667q0 .966.683 1.65A2.25 2.25 0 0 0 3.333 9"
  }));
};
var _default = cloud;
exports.default = _default;